import angular from 'angular';

import EventDetailPageComponent from './EventDetailPageComponent';
import EventDetailsDataComponent from './EventDetailsDataComponent';
import EventDetailsModalComponent from './EventDetailsModalComponent';

export default angular.module('petroCloud.base.eventDetails', [
  'cfp.hotkeys'
])
  .component(EventDetailPageComponent.name, EventDetailPageComponent)
  .component(EventDetailsDataComponent.name, EventDetailsDataComponent)
  .component(EventDetailsModalComponent.name, EventDetailsModalComponent)
  .name;
